<template>
  <section>
    <div
      class="interest"
      :style="[
        this.selected == true
          ? { 'background-color': '#38ada9', color: 'white' }
          : {},
      ]"
    >
      {{ newIcon }} {{ interest }}
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["icon", "interest", "added"],

  components: {},

  data: () => ({
    selected: false,
    newIcon: "",
  }),
  mounted() {
    this.newIcon = String.fromCodePoint(this.icon);
    this.selected = this.added;
  },

  watch: {
    icon() {
      this.newIcon = String.fromCodePoint(this.icon);
    },
    added() {
      this.selected = this.added;
    },
  },

  computed: {
    ...mapState("profile", ["canAddInterests"]),
  },

  methods: {
    select() {
      if (this.canAddInterests) {
        this.selected = !this.selected;
      } else if (!this.canAddInterests && this.selected) {
        this.selected = false;
        this.$store.commit("profile/setCanAddInterests", true);
      }
    },
  },
};
</script>

<style scoped>
.interest {
  background-color: white; /*f7f7ef*/
  border: 1px solid #b4b4b4;
  color: #555555;
  width: fit-content;
  padding: 2px;
  padding-right: 3px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  margin: 2px;
}
</style>
